var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetamask = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4426 1L25.5348 13.5039L28.6615 6.12677L42.4426 1Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41181 1L20.1837 13.6223L17.21 6.12677L3.41181 1ZM36.3609 29.984L31.8578 36.8535L41.4927 39.4931L44.2625 30.1363L36.3609 29.984ZM1.62756 30.1363L4.3804 39.4931L14.0153 36.8535L9.51223 29.984L1.62756 30.1363Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.472 18.3765L10.7871 22.4203L20.3541 22.8433L20.0142 12.6067L13.472 18.3765ZM32.385 18.3765L25.7578 12.4883L25.5369 22.8433L35.0868 22.4203L32.385 18.3765ZM14.0157 36.8531L19.7593 34.0613L14.7974 30.2036L14.0157 36.8531ZM26.0976 34.0613L31.8582 36.8531L31.0595 30.2036L26.0976 34.0613Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8555 36.8543L26.095 34.0625L26.5538 37.8018L26.5028 39.3754L31.8555 36.8543ZM14.0131 36.8543L19.3658 39.3754L19.3318 37.8018L19.7566 34.0625L14.0131 36.8543Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4514 27.7351L14.6594 26.3307L18.041 24.791L19.4514 27.7351ZM26.4015 27.7351L27.8119 24.791L31.2104 26.3307L26.4015 27.7351Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.017 36.8547L14.8326 29.9851L9.51385 30.1374L14.017 36.8547ZM31.0437 29.9851L31.8594 36.8547L36.3625 30.1374L31.0437 29.9851ZM35.088 22.4219L25.5381 22.8449L26.4217 27.7348L27.8321 24.7907L31.2307 26.3304L35.088 22.4219ZM14.6627 26.3304L18.0612 24.7907L19.4547 27.7348L20.3553 22.8449L10.7883 22.4219L14.6627 26.3304Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7871 22.4219L14.7974 30.2051L14.6615 26.3304L10.7871 22.4219ZM31.2295 26.3304L31.0595 30.2051L35.0868 22.4219L31.2295 26.3304ZM20.3541 22.8449L19.4534 27.7348L20.575 33.5045L20.8299 25.9074L20.3541 22.8449ZM25.5369 22.8449L25.0781 25.8905L25.282 33.5045L26.4205 27.7348L25.5369 22.8449Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4185 27.7344L25.2799 33.5042L26.0956 34.0625L31.0575 30.2048L31.2274 26.3301L26.4185 27.7344ZM14.6594 26.3301L14.7954 30.2048L19.7573 34.0625L20.5729 33.5042L19.4514 27.7344L14.6594 26.3301Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5028 39.3766L26.5538 37.803L26.1289 37.4308H19.7226L19.3318 37.803L19.3658 39.3766L14.0131 36.8555L15.8823 38.3783L19.6717 41.0009H26.1799L29.9863 38.3783L31.8555 36.8555L26.5028 39.3766Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0984 34.0623L25.2828 33.5039H20.5757L19.7601 34.0623L19.3353 37.8016L19.7261 37.4294H26.1324L26.5572 37.8016L26.0984 34.0623Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1577 14.3161L44.6021 7.41269L42.444 1L26.0969 13.0809L32.3843 18.3769L41.2715 20.9656L43.2427 18.6814L42.3931 18.0723L43.7525 16.8372L42.6989 16.025L44.0584 14.9929L43.1577 14.3161ZM1.27045 7.41269L2.71484 14.3161L1.79722 14.9929L3.15665 16.025L2.12009 16.8372L3.47951 18.0723L2.62987 18.6814L4.58405 20.9656L13.4713 18.3769L19.7586 13.0809L3.41154 1L1.27045 7.41269Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2718 20.9658L32.3846 18.3771L35.0864 22.4209L31.0591 30.2042L36.3609 30.1365H44.2625L41.2718 20.9658ZM13.4716 18.3771L4.58431 20.9658L1.62756 30.1365H9.51223L14.797 30.2042L10.7867 22.4209L13.4716 18.3771ZM25.5365 22.8439L26.0972 13.0811L28.6801 6.12695H17.21L19.7589 13.0811L20.3536 22.8439L20.5576 25.9234L20.5746 33.5036H25.2816L25.3155 25.9234L25.5365 22.8439Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetamask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/metamask.22274855914808afaf7cc85a2aea8191.svg";